import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import apiCall from '../../services/apiCall';

const ENDPOINT = `${APIConfiguration.repairer}interventionreports/${COMMON_QUERY_PARAMS.INTERVENTION_ID}/signature`;

export async function uploadInterventionReportSignatureCommand({
  interventionId,
  signature,
}: {
  interventionId: string;
  signature: Base64URLString;
}): Promise<BaseBackResponse> {
  try {
    const response = await apiCall(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.INTERVENTION_ID, interventionId),
      {
        method: SUPPORTED_METHODS.PUT,
        json: {
          signature,
        },
      },
    );

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}
